# Live search for the knowledge item editor lists. The form is remote so the
# controller's index.js.erb repaints only the result list, not the whole editor.

timer = null

# Below this the debounce never fires, so a single keystroke cannot trigger a full
# scan. Enter still submits, which keeps single-character CJK terms searchable.
MINIMUM_TERM_LENGTH = 2

delay = (callback, ms) ->
  clearTimeout timer
  timer = setTimeout(callback, ms)
  return

cancel_delay = ->
  clearTimeout timer
  timer = null
  return

$(document).ready ->
  # Marks the form as JS-driven so the CSS can hide the now-redundant submit button.
  $('.knowledge-search').addClass('is-live-search')

  active_request = null

  # A remote search repaints only the grid, so the form's Clear link is toggled here.
  toggle_clear = (search_input) ->
    form = search_input.closest('form')
    form.find('.knowledge-search-clear').toggleClass('is-hidden', search_input.val().trim() is '')
    return

  # 'input' also covers paste and clearing the field, which keyup misses.
  $('.knowledge-search-input').on 'input', ->
    search_input = $(this)
    term = search_input.val().trim()
    toggle_clear(search_input)

    # Emptying the field still searches, so the unfiltered list comes back; a term
    # that is merely too short drops the pending timer instead of searching.
    if term.length > 0 and term.length < MINIMUM_TERM_LENGTH
      cancel_delay()
      return

    delay (->
      search_input.closest('form').submit()
      return
    ), 1000

  # Clear through the same remote submit as typing. Following the link would reload
  # the page, which makes the chosen language dropdown flash as it re-initialises.
  $(document).on 'click', '.knowledge-search-clear', (event) ->
    event.preventDefault()
    search_input = $(this).closest('form').find('.knowledge-search-input')
    search_input.val('')
    toggle_clear(search_input)
    search_input.closest('form').submit()
    return

  # Covers Enter as well as the debounced submit: drop the pending timer so the same
  # term is not sent twice. jquery-ujs binds its submit handler at import time, so by
  # the time this runs the new request is already in flight and must not be aborted.
  $(document).on 'submit', '.knowledge-search', ->
    cancel_delay()
    return

  # Adopt the new request before aborting the one it supersedes, so the aborted
  # request's ajax:complete sees a newer active_request and leaves the state alone.
  $(document).on 'ajax:send', '.knowledge-search', (event, xhr) ->
    superseded     = active_request
    active_request = xhr
    superseded?.abort()
    $('.knowledge-search').addClass('is-searching')
    $('.knowledge-search-results').addClass('is-searching')
    return

  # Clear on complete rather than in the response, so a failed search recovers too.
  # Only the latest request may clear it; an aborted one must not unset the newer state.
  $(document).on 'ajax:complete', '.knowledge-search', (event, xhr) ->
    return unless xhr is active_request
    active_request = null
    $('.knowledge-search').removeClass('is-searching')
    $('.knowledge-search-results').removeClass('is-searching')
    return
